export default __webpack_public_path__ + "static/media/stereovolume.ee01cfde.png";